module.exports = __webpack_public_path__ + "img/malte-wingen-PDX_a_82obo-unsplash.57027210.jpg";